import { getRecipient } from "./pagarmeLib";

export const getSplitDetails = (items) => {
  // this.loading = true
  return new Promise(async (resolve, reject) => {
    let itemsList = [];
    // console.log('items: ', items)
    for (let i = 0; i < items.length; i++) {
      try {
        if (items[i].recipient_id) {
          let recipient = await getRecipient(items[i].recipient_id);
          // console.log('recipient: ', recipient)
          let item = {
            ...items[i],
            ...recipient,
          };
          itemsList.push(item);
        }
      } catch (err) {
        //   this.loading = false
        reject(err);
      }
    }
    // console.log('itemsList: ', itemsList)
    resolve(itemsList);
    //   this.loading = false
  });
};

export const getBankAccounts = (items) => {
  // this.loading = true
  return new Promise(async (resolve, reject) => {
    let itemsList = [];
    // console.log('items: ', items)
    for (let i = 0; i < items.length; i++) {
      try {
        // if(items[i].recipient_id) {
        let recipient = await getRecipient(items[i]);
        // console.log('recipient: ', recipient)
        let item = {
          // ...items[i],
          ...recipient,
        };
        itemsList.push(item);
        // }
      } catch (err) {
        //   this.loading = false
        reject(err);
      }
    }
    // console.log('itemsList: ', itemsList)
    resolve(itemsList);
    //   this.loading = false
  });
};
